export const en = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/4be9434c-fd11-40e2-916b-e47c919d5caf.png',
};

export const ja = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/ecb63151-4390-4147-84d3-c016b81775b2.png',
};
